<template>
  <div class="container">
    <!-- 筛选列表 -->
    <div
      class="filter_bg"
      v-if="tabsData[0].selected"
      @click.stop="tabsData[0].selected = false"
    ></div>
    <div class="list_main">
      <!-- 价格 -->
      <div class="price_list" v-if="tabselected == 0 && tabsData[0].selected">
        <div class="price_list_box">
          <div
            class="price_list_item"
            v-for="(item,index) in priceData"
            :key="index"
            @click.stop="priceSelect(index)"
          >
            <span>{{item.text}}</span>
            <img v-if="item.selected" src="../../assets/images/selected.png" />
          </div>
        </div>
        <div class="price_btn">
          <span class="reset" @click.stop="reset">重置</span>
          <span class="price_sure" @click.stop="priceSure">确定</span>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="mainList">
      <scroll
        :data="meetingRoomList"
        :allLoaded="noMess"
        @pulldown="loadData"
        @loadUp="loadup"
        v-if="meetingRoomList.length"
      >
        <div v-for="(item,index) in meetingRoomList" :key="index">
          <list-item :item="item"></list-item>
        </div>
      </scroll>
      <div class="noMess" v-if="meetingRoomList.length <= 0 && loading">
        <no-message text="暂无数据"></no-message>
      </div>
    </div>
  </div>
</template>

<script>
import ListItem from "./components/boardroomListItem.vue";
import Scroll from "../../components/scroll";
import NoMessage from "../../components/nomessage";
import util from "../../utils/util";
import { mapState } from "vuex";
import { getMeetingRoomListByUserId } from "../../utils/api";
export default {
  name: "meetingRoom",
  components: {
    ListItem,
    Scroll,
    NoMessage
  },
  data() {
    return {
      meetingRoomList: [],
      marketData: [], //项目列表
      pageNo: 1,
      tabsData: [{ text: "全部价格", selected: false }],
      priceData: [
        { text: "0-200", selected: false },
        { text: "200-500", selected: false },
        { text: "500-1000", selected: false },
        { text: "1000+", selected: false }
      ],
      tabselected: -1, //选中哪一个tab，默认都不选中
      marketSelected: false,
      priceSelected: false,
      noMess: false, //判断是否加载最后
      prices: "", //选择的价格
      marketId: "",
      loading: false
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.getMeetingRoomListByUserId();
  },
  activated() {},
  methods: {
    // 上拉加载
    loadup() {
      if (this.noMess) {
        return;
      }
      this.pageNo++;
      this.getMeetingRoomListByUserId();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      this.getMeetingRoomListByUserId();
    },
    // 点击tab
    tabClick(index){
      let data = this.tabsData;
      data.forEach((item,i)=>{
        if(i==index){
          item.selected = !item.selected
        }else{
          item.selected = false
        }
      })
      this.tabsData = data;
      this.tabselected = index;
    },
    // 价格筛选
  priceSelect(index){
    let priceData = this.priceData;
        priceData[index].selected = !priceData[index].selected;
  },
  // 重置价格
  reset(){
    let priceData = this.priceData;
    priceData.forEach(item=>{
      item.selected = false
    })
    this.priceData = priceData
  },
  priceSure(){
    let priceData = this.priceData;
    let tabsData = this.tabsData;
    let prices = [],priceText = [],hasSelect=false;
    priceData.forEach((item,index)=>{
      if(item.selected){
        hasSelect = true;
        prices.push(index)
        priceText.push(item.text)
      }
    })
    if(!hasSelect){
      tabsData[0].selected = false
      tabsData[0].text = '全部价格'
      this.prices = prices.join(",")
      this.pageNo = 1
      this.noMess = false
    }else{
      tabsData[0].selected = false
      if(priceText.length > 1){
        tabsData[0].text = priceText.join(";")
      }else{
        tabsData[0].text = priceText.toString()
      }
      this.priceData = priceData;
      this.prices = prices.join(",");
      this.pageNo = 1;
      this.noMess = false;
    }
    this.getMeetingRoomListByUserId()
  },
    // 获取会议室列表数据
    getMeetingRoomListByUserId() {
      this.loading = false;
      if (this.noMess) {
        return false;
      }
      util.showLoading("加载中...");
      getMeetingRoomListByUserId({
        pageNo: this.pageNo,
        marketId: this.common.marketInfo.id,
        pageSize: 5,
        prices: this.prices,
        queryDate: util.formatTime(new Date(), 4)
      }).then(res => {
        console.log(res);
        if (res.res.code == 10000) {
          let data = res.body.meetingRoomList;
          data.forEach(item => {
            let status = item.meetingStatus;
            if (item.meetingStatus) {
              item.amData = status.slice(0, 25);
              item.pmData = status.slice(24).concat([1]);
            }
          });
          if (res.body.meetingRoomList.length != 5) {
            this.noMess = true;
          }
          if (this.pageNo == 1) {
            this.meetingRoomList = res.body.meetingRoomList;
          } else {
            this.meetingRoomList = this.meetingRoomList.concat(
              res.body.meetingRoomList
            );
          }
        }
        util.hideLoading();
        this.loading = true;
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: @colore;
}
span,
img {
  display: block;
}
.noMess {
  margin-top: 200px;
}
.mainList {
  height:100vh;
  // padding-top:88px;
  box-sizing:border-box;
}
/* tab */
.tabs_box {
  position: fixed;
  top: 0;
  left: 0;right:0;
  z-index: 33;
  height: 88px;
  padding:0 28px;
  box-sizing:border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: @colore;
}
.tabs_item {
  height: 88px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.tabs_item span {
  font-size: 32px;
  color: rgba(51, 51, 51, 1);
  margin-right: 8px;
  white-space: nowrap;
  max-width: 224px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tabs_item_selected span {
  // color: @color17;
}
.tabs_item img {
  width: 24px;
  height: 24px;
}
/* 筛选列表 */
.list_main {
  position: fixed;
  top: 87px;
  left: 0;
  right: 0;
  z-index: 33;
  background: #fff;
}
.price_list {
  padding: 28px;
}
.price_list_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 0;
}
.price_list_item {
  position: relative;
  width: 158px;
  height: 68px;
  box-sizing: border-box;
  .border();
  text-align: center;
  line-height: 68px;
  border-radius: 8px;
  overflow: hidden;
}
.price_list_item span {
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
}
.price_list_item img {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 36px;
  height: 36px;
}
.price_btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 68px;
}
.price_btn span {
  width: 192px;
  height: 68px;
  box-sizing: border-box;
  text-align: center;
  line-height: 68px;
  margin-left: 20px;
  border-radius: 8px;
  .border();
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
}
.price_btn span.price_sure {
  border-color: @color17;
  background: @color17;
  color: #fff;
}
/* market_list */
.city_title {
  width: 710px;
  padding-left: 40px;
  height: 76px;
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  line-height: 76px;
  background: rgba(248, 248, 248, 1);
}
.market_item {
  padding: 28px 40px 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.market_item_last {
  padding-bottom: 40px;
}
.market_item span {
  font-size: 32px;
  color: rgba(51, 51, 51, 1);
}
.market_item img {
  width: 32px;
  height: 32px;
}
.market_item_select span {
  color: @color17;
}
.scroll_view {
  height: 604px;
}
/* market_list end*/

.filter_bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 22;
}
</style>